export const isElementRendered = async (selector: string, animationFramesToWait: number) => {
  let animations = 0;
  while (document.querySelector(selector) === null) {
    if (animations > animationFramesToWait) {
      break;
    }
    await new Promise((resolve) => requestAnimationFrame(resolve));
    animations++;
  }

  return animations < animationFramesToWait;
};

export const setDomainHostname = () => {
  const domain = window.location.hostname.split('.').reverse();
  if (domain[0] !== 'localhost') {
    document.domain = domain.length > 1 ? domain[1] + '.' + domain[0] : domain[0];
  }
};

export const scrollToElement = (el: HTMLElement) => {
  const y = el.getBoundingClientRect().top + window.pageYOffset - 100;
  window.scrollTo({ top: y, behavior: 'smooth' });
};



// WEBPACK FOOTER //
// ./ts/app/shared/dom-utils.ts